import { render, staticRenderFns } from "./LoginDashboard.vue?vue&type=template&id=6f359455"
import script from "./LoginDashboard.vue?vue&type=script&lang=js"
export * from "./LoginDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports